import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import translate from "../../../i18n/translate";
import { setTemplateTitle } from "../../../redux/actions/soundsOfEnglishActions";
import Loader from "../../shared/Loader/Loader";
import { LANGUAGE_CODES, PHONEME_DATA_LIST } from "./FeatureCourse/constants";
import { refreshHighlight } from "./FeatureCourse/speechService";
import "./soundsOfEnglish.scss";
import { useNavigate } from "react-router-dom";
import { removeBoldTags } from "./soeService";

const SoundsOfEnglish = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [showLoader, setShowLoader] = React.useState<boolean>(true);
  const [selectedCode, setSelectedCode] = useState<number>(1);
  const [vowelsList, setVowelsList] = useState<any>([]);
  const [consonantsList, setConsonantsList] = useState<any>([]);
  const [newHighLightIds, setNewHighLightIds] = useState<any[]>([]);
  const { data } = useSelector((state: any) => state.soundsOfEnglish);

  const handleLanguageSelect = async (e: any) => {
    setNewHighLightIds([]);
    setSelectedCode(e.target.value);
    const highlighValue: any = refreshHighlight(e.target.value, data);
    setNewHighLightIds(highlighValue ?? []);
  };

  useEffect(() => {
    if (PHONEME_DATA_LIST.length > 0) {
      const VOWELS_LIST = PHONEME_DATA_LIST.slice().splice(0, 15);
      setVowelsList(VOWELS_LIST);
      const CONSONANTS_LIST = PHONEME_DATA_LIST.slice().splice(15, PHONEME_DATA_LIST.length - 14);
      setConsonantsList(CONSONANTS_LIST);
      setShowLoader(false);
    }
  }, []);


  const toEdgeActivityPlayer = (activityId: any, activity: any) => {
    const title = removeBoldTags(activity);
    navigate(`/soundsofenglish/${activityId}/`, { state: title });
    dispatch(setTemplateTitle(title));
  };

  const checkIdInHighLightArray = (id: any) => {
    return newHighLightIds.includes(id);
  };

  return (
    <>
      {showLoader && <Loader showLoader={showLoader} />}
      <div className="sounds-of-english-wrapper">
        <div className="sounds-of-english-container">
          <div className="feature-details-header">
            <h5 className="feature-title">{translate("soe_product_headline")}</h5>
            <div className="feature-description-box">
              <div className="feature-description-wrapper">
                <p className="feature-description">{translate("soe_product_description")}</p>
                <p className="feature-select-language">{translate("soe_product_language_selection")}</p>
                <div className="feature-language-selection-box">
                  <select value={selectedCode} onChange={handleLanguageSelect} className="feature-language-select">
                    {LANGUAGE_CODES.map((codes: any) => (
                      <option key={codes.id} value={codes.id} className="feature-language-option">
                        {codes.title}
                      </option>
                    ))}
                  </select>
                  <div className="feature-language-message">
                    <p className="feature-language-dot">●</p>
                    <p className="feature-language-words">= Focus on these sounds.</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="soe-detail-wrapper">
            <div className="soe-vowels-container">
              <p className="container-title">{translate("soe_product_vowels")}</p>
              <div className="each-vocab-boxes">
                {vowelsList.map((vowelsList: any) => (
                  <button
                    key={`${vowelsList.Id}`}
                    data-testid={`data-test${vowelsList.Id}`}
                    className={`each-vocab-box ${checkIdInHighLightArray(vowelsList.Id) ? "highlight" : ""}`}
                    onClick={() =>
                      toEdgeActivityPlayer(vowelsList.Id, `${vowelsList.symbol} (${vowelsList.Words[0] ?? ""})`)
                    }
                  >
                    <p className="each-vocab-symbol">{vowelsList.symbol}</p>
                    <p
                      className="each-vocab-word"
                      dangerouslySetInnerHTML={{ __html: `(${vowelsList.Words[0] ?? ""})` }}
                    ></p>
                  </button>
                ))}
              </div>
            </div>
            <div className="soe-consonants-container">
              <p className="container-title">{translate("soe_product_consonants")}</p>
              <div className="each-vocab-boxes">
                {consonantsList.map((consonantsList: any) => (
                  <button
                    key={`${consonantsList.Id}`}
                    className={`each-vocab-box ${checkIdInHighLightArray(consonantsList.Id) ? "highlight" : ""}`}
                    onClick={() =>
                      toEdgeActivityPlayer(
                        consonantsList.Id,
                        `${consonantsList.symbol}(${consonantsList.Words[0] ?? ""})`,
                      )
                    }
                  >
                    <p className="each-vocab-symbol">{consonantsList.symbol}</p>
                    <p
                      className="each-vocab-word"
                      dangerouslySetInnerHTML={{ __html: `(${consonantsList.Words[0] ?? ""})` }}
                    ></p>
                  </button>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default SoundsOfEnglish;
